module.exports = __webpack_public_path__ + "img/credit.a3efa3b6.png";